import { isNotEmptyAny } from '@lhb/func';

export const EMPTY_TERMINATE_TEXT = '-';
export const rejectTipImg = `${process.env.STATIC_RES_DOMAIN}/project-custom/location-insight/reject_tip.png`;

export interface TaskTerminateInfoData {
  closeReasonName?: string;
  closeDetailReason?: string;
  closeApprovalReason?: string;
}

interface TaskTerminateApprovalDetail {
  type?: number;
  typeValue?: number;
  status?: number;
  closeReasonName?: string;
  applyReason?: string;
  curApproveReason?: string;
  preApproveReason?: string;
}

export interface TaskTerminateReasonDetailItem {
  label: string;
  value?: string;
}

interface TaskTerminateColumnsConfig {
  closeReasonFilterConfig?: any;
}

const TASK_CHANGE_APPROVAL_TYPE = 2;
const TERMINATE_TASK_APPROVAL_TYPE_VALUE = 4;
const APPROVAL_STATUS_PASSED = 1;
const TASK_STATUS_CLOSED = 50;

export function formatTerminateReasonText(data: TaskTerminateInfoData = {}) {
  const { closeReasonName, closeDetailReason } = data;
  const reasonTexts = [closeReasonName, closeDetailReason].filter(item => isNotEmptyAny(item));
  return reasonTexts.length ? reasonTexts.join(' / ') : EMPTY_TERMINATE_TEXT;
}

export function formatTerminateText(value: any) {
  return isNotEmptyAny(value) ? value : EMPTY_TERMINATE_TEXT;
}

export function getTerminateReasonDetailItems(data: TaskTerminateInfoData = {}): TaskTerminateReasonDetailItem[] {
  return [
    {
      label: '具体理由',
      value: data.closeDetailReason,
    },
    {
      label: '审批理由',
      value: data.closeApprovalReason,
    },
  ];
}

export function getTaskTerminateColumns(config: TaskTerminateColumnsConfig = {}) {
  const { closeReasonFilterConfig } = config;

  return [
    {
      key: 'closeReasonName',
      title: '关闭理由',
      width: 220,
      dragChecked: true,
      filterConfig: closeReasonFilterConfig,
      staticTooltipTitle: (value: any) => formatTerminateText(value),
      render: (value: any) => formatTerminateText(value),
    },
    {
      key: 'closeDetailReason',
      title: '具体理由',
      width: 220,
      dragChecked: true,
      staticTooltipTitle: (value: any) => formatTerminateText(value),
      render: (value: any) => formatTerminateText(value),
    },
    {
      key: 'closeApprovalReason',
      title: '审批理由',
      width: 220,
      dragChecked: true,
      staticTooltipTitle: (value: any) => formatTerminateText(value),
      render: (value: any) => formatTerminateText(value),
    },
  ];
}

export function buildTaskTerminateInfoDetail<T extends TaskTerminateInfoData & { status?: number }>(
  taskDetail: T,
  approvalDetail: TaskTerminateApprovalDetail = {}
): T {
  if (
    approvalDetail?.type !== TASK_CHANGE_APPROVAL_TYPE ||
    approvalDetail?.typeValue !== TERMINATE_TASK_APPROVAL_TYPE_VALUE ||
    approvalDetail?.status !== APPROVAL_STATUS_PASSED
  ) {
    return taskDetail;
  }

  return {
    ...taskDetail,
    status: TASK_STATUS_CLOSED,
    closeReasonName: isNotEmptyAny(taskDetail?.closeReasonName)
      ? taskDetail.closeReasonName
      : approvalDetail.closeReasonName,
    closeDetailReason: isNotEmptyAny(taskDetail?.closeDetailReason)
      ? taskDetail.closeDetailReason
      : approvalDetail.applyReason,
    closeApprovalReason: isNotEmptyAny(taskDetail?.closeApprovalReason)
      ? taskDetail.closeApprovalReason
      : (approvalDetail.curApproveReason || approvalDetail.preApproveReason),
  };
}
